module.exports = __webpack_public_path__ + "img/VCGMarkets_new_black_logo.192ae674.svg";